/* eslint-disable react/destructuring-assignment */
/* eslint-disable camelcase */
import React, { useEffect, useRef, useState } from 'react';

import { Formik } from 'formik';
import * as Yup from 'yup';
import { TextField } from '@mui/material';
import { BehaviorSubject } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { ITEM_DEFAULTS } from '../../../../../config/deviceConfig/item_defaults';
import { IDFField } from '../../../../../config/deviceConfig/types';
import { FORM_DEBOUNCE_TIME } from '../../../../../config/deviceConfig/Values';
import { IFormResetRef, FormResetAction } from '../../../ProDeviceCreateEdit/types';
import { appConsoleLog } from '../../../../../utility/appUtils';

const FIELD_NAME = ITEM_DEFAULTS.ITEM_CREATOR.DEVICE_FIELDS.relay_value;

type ComponentProps = {
  fieldConfig: IDFField;
  validateForm: number;
  deviceInfo: any;
  resetForm: IFormResetRef;
  onChange: (payload: any, isInitializing?: boolean) => void;
};
interface IformData {
  relay_close_value: number;
  relay_open_value: number;
}
// eslint-disable-next-line import/prefer-default-export
export const ProDeviceFieldRelayValues: React.FunctionComponent<ComponentProps> = (props) => {
  const [deb, setDeb] = useState<BehaviorSubject<{values: IformData; errors: any} | null>>();

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const onSubmitForm = (formData: IformData) => {};

  const sendDefaults = () => {
    if (!props.fieldConfig || !deb) {
      return;
    }
    deb.next({
      values: {
        relay_close_value: props.fieldConfig.default[0],
        relay_open_value: props.fieldConfig.default[1],
      },
      errors: {},
    });
  };

  /**
   * Resetting or changing form data from parent
   */
  const refFormReset = useRef<IFormResetRef>({
    ref: 0,
    action: '',
    info: {},
  });
  useEffect(() => {
    if (
      formRef.current
      && props.resetForm.ref > 0
      && props.resetForm.ref > refFormReset.current.ref
    ) {
      refFormReset.current = props.resetForm;
      appConsoleLog('relay value reset', props.resetForm.info);
      if (props.resetForm.action === FormResetAction.toCurrentInfo) {
        appConsoleLog({ name: props.resetForm.info.name });
        const values = props.resetForm.info.settings[props.fieldConfig.field];
        if (values && values.length === 2) {
          formRef.current.setValues({
            relay_close_value: values[0],
            relay_open_value: values[1],
          });
        }
      } else {
        formRef.current.resetForm();
      }
    }
  }, [props.resetForm]);
  const initilized = useRef(0);
  useEffect(() => {
    const b = new BehaviorSubject<{values: IformData; errors: any} | null>(null);
    setDeb(b);
    const sub = b
      .pipe(
        debounceTime(FORM_DEBOUNCE_TIME),
        map((v) => JSON.stringify(v)),
        distinctUntilChanged(),
        map((v) => JSON.parse(v)),
      )
      .subscribe((v: {values: IformData; errors: any} | null) => {
        if (v == null || props.fieldConfig == null) {
          return;
        }

        const { values, errors } = v;
        const infoData: any = {
          settings: {},
        };

        infoData.settings[props.fieldConfig.field] = [
          +values.relay_close_value,
          +values.relay_open_value,
        ];
        if (initilized.current === 0) {
          props.onChange(
            {
              action: 'data',
              form: FIELD_NAME,
              data: infoData,
              errors,
            },
            true,
          );
          initilized.current = 1;
        } else {
          props.onChange({
            action: 'data',
            form: FIELD_NAME,
            data: infoData,
            errors,
          });
        }
      });

    // send once default data
    sendDefaults();
    return () => {
      sub.unsubscribe();
    };
  }, [props.fieldConfig]);

  const formRef = useRef<any>();
  useEffect(() => {
    if (formRef && formRef.current !== undefined && props.validateForm !== 0) {
      formRef.current.submitForm();
    }
  }, [props.validateForm]);
  let isEditable = props.fieldConfig != null && props.fieldConfig.editable === true;
  if (isEditable) {
    if (props.deviceInfo.settings[`has_${props.fieldConfig.field}`] === false) {
      isEditable = false;
    }
  }

  return isEditable === true ? (
    <div>
      <Formik
        innerRef={formRef}
        initialValues={{
          relay_close_value: props.fieldConfig.default[0],
          relay_open_value: props.fieldConfig.default[1],
        }}
        validationSchema={Yup.object().shape({
          relay_close_value: Yup.number().required('Required'),
          relay_open_value: Yup.number().required('Required'),
        })}
        validateOnChange
        onSubmit={onSubmitForm}
      >
        {({
          errors, handleBlur, handleChange, touched, values, submitForm,
        }) => {
          deb?.next({
            values,
            errors,
          });
          return (
            <form>
              <div className="row">
                <div className="col-md-2">
                  <TextField
                    className="dynamic-ui-form-control "
                    error={Boolean(touched.relay_close_value && errors.relay_close_value)}
                    helperText={touched.relay_close_value && errors.relay_close_value}
                    onBlur={handleBlur}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                    value={values.relay_close_value}
                    name="relay_close_value"
                    label="Relay On value"
                    size="small"
                    variant="outlined"
                  />
                </div>
                <div className="col-md-2">
                  <TextField
                    className="dynamic-ui-form-control "
                    error={Boolean(touched.relay_open_value && errors.relay_open_value)}
                    helperText={touched.relay_open_value && errors.relay_open_value}
                    onBlur={handleBlur}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                    value={values.relay_open_value}
                    name="relay_open_value"
                    label="Relay off value"
                    size="small"
                    variant="outlined"
                  />
                </div>
              </div>
            </form>
          );
        }}
      </Formik>
    </div>
  ) : (
    <div />
  );
};
